import { render, staticRenderFns } from "./SuggestionsPictures.vue?vue&type=template&id=e0a0de22"
import script from "./SuggestionsPictures.vue?vue&type=script&lang=js"
export * from "./SuggestionsPictures.vue?vue&type=script&lang=js"
import style0 from "./SuggestionsPictures.vue?vue&type=style&index=0&id=e0a0de22&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports